import React from "react";
import QuickUpdatescard from "../QuickUpdatescard";
import CareTeamLayout from "./CaewTeamLayout";
import { FiPlus } from "react-icons/fi";
import GroupActivity from "./assets/groupActivity.png";
import { useEffect } from "react";
import { useState } from "react";

function CareTeamGroup({ isLoading, selectedGroup }) {
  const [providerId,setProviderId] = useState()

  useEffect(()=>{
    setProviderId(selectedGroup.createdBy)
  },[selectedGroup.createdBy])
  return (
    <div className="d-flex flex-column justify-content-between">
      <div>
        {isLoading ? (
          <center>
            <div
              style={{
                width: "3rem",
                height: "3rem",
                color: "#1f7e78",
                top: "10px",
                position: "relative",
              }}
              className="spinner-border mt-3 mb-4"
              role="status"
            />
          </center>
        ) : // posts.length > 0 ? (
        //   posts.slice(0, 3).map((dt, i) => (
        //     <QuickUpdatescard
        //       key={i}
        //       dt={dt}
        //       getGroupPosts={getGroupPosts}
        //     />
        //   ))
        // )
        selectedGroup ? (
          <CareTeamLayout selectedGroup={selectedGroup} providerId={providerId}/>
        ) : (
          <CareTeamLayout />
        )}
      </div>
        <div
          className=" position-relative"
          style={{
            marginTop:'80px',
            border: "1px solid black",
            borderRadius: "20px",
          }}
        >
          <div
            className="position-relative d-flex align-items-end justify-content-between"
            style={{
              height: "200px",
              width: "95%",
              borderRadius: "20px",
              top: "-10px",
              left: "10px",
              backgroundColor: "rgba(47, 156, 149, 1)",
              color: "white",
            }}
          >
            <p
              className="p-2 mb-4"
              style={{ fontSize: "0.9rem", width: "30%" }}
            >
              Click on any group to resume conversations
            </p>
            <img
              src={GroupActivity}
              alt="hello"
              className="position-relative ps-1"
              style={{
                bottom: "20px",
                height: "130%",
                width: "70%",
                right: "0px",
              }}
            />
          </div>
        </div>
    </div>
  );
}

export default CareTeamGroup;
